import { ChatRole } from 'components/Chat/chatConstants';

const toAssistantMessages = (messages = []) => {
    return messages.map((message) => ({
        ...(message.role === ChatRole.ASSISTANT
            ? {
                  status: {
                      type: 'complete',
                      reason: 'stop',
                  },
              }
            : {}),
        ...(message.role === ChatRole.USER
            ? {
                  attachments: [],
              }
            : {}),
        id: message.id,
        role: message.role,
        createdAt: new Date(message.created_on || Date.now()),
        content: [{ type: 'text', text: message.message_text || '' }],
        metadata: {
            ...(message.role === ChatRole.ASSISTANT
                ? {
                      unstable_annotations: [],
                      unstable_data: [],
                      unstable_state: null,
                      steps: [],
                  }
                : {}),
            custom: {
                message_context: message.message_context,
                system_type: message.system_type,
                system_data: message.system_data,
            },
        },
    }));
};

const getMessageText = (parts = []) => {
    return parts
        .filter((part) => part.type === 'text')
        .map((part) => part.text || '')
        .join('\n\n');
};

const getLatestUserMessageText = (threadMessages = []) => {
    const latestUserMessage = [...threadMessages].reverse().find((message) => message.role === ChatRole.USER);
    if (!latestUserMessage) return '';

    return getMessageText(latestUserMessage.content || []).trim();
};

const normalizeMessageContext = (messageContext) => {
    if (!messageContext?.key) return null;

    return {
        name: messageContext.name || '',
        type: messageContext.type || '',
        bucket: messageContext.bucket || '',
        key: messageContext.key,
    };
};

const getAiChatPayload = (message = {}) => {
    if (message?.payload && typeof message.payload === 'object') {
        return message.payload;
    }

    return message;
};

const getLatestMessageContext = (messages = []) => {
    const latestMessageWithContext = [...messages].reverse().find((message) => message.message_context);

    return normalizeMessageContext(latestMessageWithContext?.message_context);
};

const formatDateLabel = (value) =>
    new Intl.DateTimeFormat('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
    }).format(new Date(value));

const formatTimeLabel = (value) =>
    new Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        minute: '2-digit',
    }).format(new Date(value));

const getDateKey = (value) => {
    const date = new Date(value);
    return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
};

const preserveMarkdownLineBreaks = (text = '') => {
    return text.replace(/([^\n])\n([^\n])/g, '$1  \n$2');
};

const hasAssistantStreamingOutput = ({ isRunning, messages }) => {
    if (!isRunning) return false;

    const latestMessage = messages[messages.length - 1];
    if (!latestMessage || latestMessage.role !== ChatRole.ASSISTANT) return false;

    return Boolean(getMessageText(latestMessage.content || []).trim());
};

export {
    formatDateLabel,
    formatTimeLabel,
    getDateKey,
    getAiChatPayload,
    getLatestUserMessageText,
    getLatestMessageContext,
    getMessageText,
    hasAssistantStreamingOutput,
    normalizeMessageContext,
    preserveMarkdownLineBreaks,
    toAssistantMessages,
};
